export default __webpack_public_path__ + "static/media/RivetDiagramImg.e8c4cc8d.jpg";